import { GetStaticPropsContext, NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { usePageTitle } from '~/utils/tags'
import Metatags from '~/components/Metadata/Metatags'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { GetProps } from '~/utils/pageWrapper/types'
import MathTopics from '~/MathTopics/MathTopics.page'
import { getMathTopicsData, getRunningQueriesThunk } from '~/MathTopics/redux/math-topics.api'

const MathTopicsPage: NextPage = () => {
  const { t } = useTranslation('mathTopics')

  const pageTitle = usePageTitle(t('pageTitle'))

  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} title={pageTitle} />

      <DefaultLayout zeroPadding>
        <MathTopics />
      </DefaultLayout>
    </div>
  )
}

export const getProps: GetProps =
  (store) =>
  async ({ locale }: GetStaticPropsContext) => {
    store.dispatch(getMathTopicsData.initiate({ language: locale as string }))
    await Promise.all(store.dispatch(getRunningQueriesThunk()))

    return {
      props: {
        namespaces: [...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES, 'mathTopics'],
      },
    }
  }

export const getStaticProps = getStaticPropsWrapper(getProps)

export default MathTopicsPage
